import { IStateService } from 'angular-ui-router';
import { includes } from 'lodash';
import { ISdcStore } from 'src/app/sdc/flux/sdc-store.interface';
import { ISdcActivity } from '../../../sdc/sdc-state/sdc-state.typings';
import { SdcStateService } from './../../../sdc/sdc-state/sdc-state.service';

export interface ICurrentState {
  sdcName: string;
  name: string;
  filterWidgetIsVisible: boolean;
  sdcMenuIsVisible: boolean;
  availableSdcViews: ISdcActivity['availableSdcViews'];
  stickyToolbar: boolean;
  hideToolbar: boolean;
}

const validStateNames = [
  'main.school.new-sdc.grad-planning.grid',
  'main.school.new-sdc.regents-planning.grid',
  'main.school.new-sdc.regents-prep.grid',
  'main.school.new-sdc.credit-gaps.grid',
  'main.school.new-sdc.attendance.grid',
  'main.school.new-sdc.marking-period.grid',
  'main.school.new-sdc.default-sdc.grid',
];

const validSdcStates = ['single-student', 'grid', 'wizard'];

const statesWithoutStickytToolbar = ['grid'];

const statesWithoutSchoolToolbar = ['single-student'];

export class SchoolToolbarService {
  static $inject: string[] = ['SDCStore', 'SdcStateService', '$state'];

  constructor(private sdcStore: ISdcStore, private sdcStateService: SdcStateService, private $state: IStateService) {}

  public getCurrentState(): ICurrentState {
    const state = this.sdcStore.getUiState().currentActivity.state;
    const activity = this.sdcStateService.determineSdcActivityFromState(state);
    const currName = this.$state.current.name;
    const filterWidgetIsVisible = includes(validStateNames, currName);
    const isValidSdcState = validSdcStates.some(state => currName.includes(state));
    const sdcMenuIsVisible = isValidSdcState;
    const stickyToolbar = statesWithoutStickytToolbar.every(state => !currName.includes(state));
    const hideToolbar = statesWithoutSchoolToolbar.some(state => currName.includes(state));
    const sdcName = isValidSdcState && activity && activity.humanName;

    const currentState: ICurrentState = {
      sdcName,
      name: currName,
      filterWidgetIsVisible,
      sdcMenuIsVisible,
      availableSdcViews: activity && activity.availableSdcViews,
      stickyToolbar,
      hideToolbar,
    };

    return currentState;
  }
}
